import { MdContentCopy } from 'react-icons/md'
import { toast } from 'react-toastify'

interface UnmatchedImportsPanelProps {
    /** Nomes que a IA leu do pedido e que não casaram com o catálogo. */
    names: string[]
    /** Some com a lista inteira. */
    onClear: () => void
    /**
     * Joga o nome no campo de busca e o remove da lista — o operador procura à
     * mão o que a extração não achou.
     */
    onPick: (name: string) => void
}

/**
 * O que a importação do pedido de exames NÃO encontrou no catálogo.
 *
 * Fica visível em vez de sumir em silêncio: o item existe no papel do paciente,
 * e sem esta lista o operador só descobriria a ausência conferindo item a item.
 */
export default function UnmatchedImportsPanel({
    names,
    onClear,
    onPick,
}: UnmatchedImportsPanelProps) {
    if (names.length === 0) return null

    return (
        <div className="rounded-xl border border-warning/40 bg-warning/5 p-4">
            <div className="mb-2 flex items-center justify-between">
                <p className="text-xs font-semibold text-base-content/70">
                    Não encontrados no catálogo ({names.length})
                </p>
                <button
                    type="button"
                    className="btn btn-ghost btn-xs"
                    onClick={onClear}
                    title="Limpar todos"
                >
                    Limpar
                </button>
            </div>
            <div className="flex flex-wrap gap-1.5">
                {names.map(name => (
                    <button
                        key={name}
                        type="button"
                        className="badge badge-outline max-w-full cursor-pointer gap-1 hover:bg-base-200"
                        title="Clique para copiar e buscar"
                        onClick={async () => {
                            try {
                                await navigator.clipboard.writeText(name)
                                onPick(name)
                                toast.success('Copiado para a busca', {
                                    autoClose: 2000,
                                })
                            } catch {
                                toast.error('Falha ao copiar')
                            }
                        }}
                    >
                        <MdContentCopy className="shrink-0 text-xs" />
                        <span className="truncate">{name}</span>
                    </button>
                ))}
            </div>
            <p className="mt-2 text-[10px] text-base-content/60">
                Clique em um item para copiar o nome, jogar no campo de busca e
                removê-lo desta lista.
            </p>
        </div>
    )
}
